import { render, staticRenderFns } from "./Diferenciais.vue?vue&type=template&id=7b0d9922&scoped=true&"
import script from "./Diferenciais.vue?vue&type=script&lang=js&"
export * from "./Diferenciais.vue?vue&type=script&lang=js&"
import style0 from "./Diferenciais.vue?vue&type=style&index=0&id=7b0d9922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d9922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VFlex,VLayout})
